// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1_vta","notes":"Notes_notes__3TUNJ"};